import { render, staticRenderFns } from "./JobTypeManagement.vue?vue&type=template&id=31c6e988"
import script from "./JobTypeManagement.vue?vue&type=script&lang=js"
export * from "./JobTypeManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports